import { render } from "./PasswordRecovery.vue?vue&type=template&id=30fabc78&scoped=true"
import script from "./PasswordRecovery.vue?vue&type=script&lang=js"
export * from "./PasswordRecovery.vue?vue&type=script&lang=js"

import "./PasswordRecovery.vue?vue&type=style&index=0&id=30fabc78&scoped=true&lang=css"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fabc78"]])

export default __exports__